import React, {useState} from "react";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import DirectDataEstimatedIncomeTable from "./DirectDataEstimatedIncomeTable/DirectDataEstimatedIncomeTable";

function DirectDataEstimatedIncomeCard(props) {

    const {direct_data_estimated_income} = props

    const [expanded, setExpanded] = useState(false);

    const handleExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };
    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
            <div
                className={["blueText", "subtitleSize", "bold"].join(" ")}
                style={{margin:"auto 0px"}}
            >
                Renda Estimada
            </div>
            {direct_data_estimated_income.data.length === 0 ?
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>
                : null
                }
            </div>

            {direct_data_estimated_income.data.length === 0 ?
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div className={["labelText", "normalMediumSize", "internalCardContainer"].join(" ")}
                        style={{textAlign: "center"}}>
                    Sem registro de renda estimada para o CPF
                </div>
            </Collapse> :
                <div className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}>
                    <DirectDataEstimatedIncomeTable direct_data_estimated_income_data={direct_data_estimated_income.data}/>
                </div>
            }
        </div>
    );
}


export default DirectDataEstimatedIncomeCard
